import type { ScheduleData } from './types';

export const mockSchedule: ScheduleData = {
  date: '2026-09-08',
  rooms: [
    { id: 'room-261', name: '教室261', status: 'current', summaryTitle: 'zt-class-3-按月计费', summaryMeta: 'u经济后果' },
    { id: 'multimedia-3', name: '多媒体3教', status: 'past', summaryTitle: '今日课程已结束', summaryMeta: '课程已上完' },
    { id: 'qinghua', name: '青花楼', status: 'idle', summaryTitle: '今日无课', summaryMeta: '空闲中' },
    { id: 'seating-test', name: '选座测试', status: 'past', summaryTitle: '今日课程已结束', summaryMeta: '空闲中' },
    { id: 'virtual', name: '虚拟教室', status: 'past', summaryTitle: '今日课程已结束', summaryMeta: '空闲中' },
    { id: 'room-6', name: '教室6', status: 'idle', summaryTitle: '今日无课', summaryMeta: '空闲中' },
    { id: 'room-12', name: '教室12', status: 'idle', summaryTitle: '今日无课', summaryMeta: '空闲中' },
    { id: 'room-8', name: '教室8', status: 'past', summaryTitle: '今日课程已结束', summaryMeta: '空闲中' },
    { id: 'room-10', name: '教室10', status: 'future', summaryTitle: 'zt-class-2-按天计费', summaryMeta: '杨满杨满文' },
    { id: 'room-13', name: '教室13', status: 'idle', summaryTitle: '今日无课', summaryMeta: '空闲中' },
    { id: 'room-21', name: '教室21', status: 'idle', summaryTitle: '今日无课', summaryMeta: '空闲中' },
    { id: 'room-26', name: '教室26', status: 'past', summaryTitle: '今日课程已结束', summaryMeta: '空闲中' }
  ],
  courses: [
    {
      id: 'course-261-current',
      roomId: 'room-261',
      name: 'zt-class-3-按月计费',
      startTime: '2026-09-08T00:00:00',
      endTime: '2026-09-08T23:59:00',
      teacherName: 'u经济后果',
      assistantName: '—',
      headTeacherName: '—',
      attendanceCount: 0,
      studentCount: 0
    },
    {
      id: 'course-multimedia',
      roomId: 'multimedia-3',
      name: '机器人启蒙班',
      startTime: '2026-09-08T09:00:00',
      endTime: '2026-09-08T10:30:00',
      teacherName: '李想',
      assistantName: '陈老师',
      headTeacherName: '王老师',
      attendanceCount: 10,
      studentCount: 10
    },
    {
      id: 'course-room-10',
      roomId: 'room-10',
      name: '创意美术课',
      startTime: '2026-09-08T19:00:00',
      endTime: '2026-09-08T20:30:00',
      teacherName: '杨满',
      assistantName: '—',
      headTeacherName: '刘老师',
      attendanceCount: 0,
      studentCount: 12
    }
  ]
};
